import classes from "./Register3.module.css";
import logo from "./../../assets/icons/Logo_register.png";
import { useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";

function Register3() {
  const pin = useRef();
  const location = useLocation();
  const phone = location.state.phone;
  const navigate = useNavigate();

  const [hasFailed, setHasFailed] = useState(false);
  const [message, setMessage] = useState(null);
  const token = localStorage.getItem("token");

  function enter() {
    setHasFailed(false);
    setMessage(null);
    const data = new URLSearchParams();
    data.append("code", pin.current.value);
    data.append("token", token);

    axios
      .post(`${process.env.REACT_APP_API_URL}/api/v1/user/check`, data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((response) => {
        const respObj = response.data;
        if (respObj) {
          const date = new Date();
          let time = date.getTime();
          toast.success("ثبت نام شما با موفقیت انجام شد");
          navigate("/", { state: { Object: respObj } });
        } else {
          setMessage(respObj.message);
          toast.error("Invalid code. Please try again.");
        }
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          toast.error(error.response.data.error.description);
        } else {
          toast.error("An error occurred. Please try again.");
        }
      });
  }

  function resendCode() {
    setHasFailed(false);
    setMessage(null);

    const data = new URLSearchParams();
    data.append("code", pin.current.value); // Sending an empty code or the original code to trigger resend logic
    data.append("token", token);

    axios
      .post("http://193.151.138.146:80/api/v1/user/check", data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((response) => {
        toast.success("The code has been resent successfully.");
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          toast.error(error.response.data.error.description);
        } else {
          toast.error("Failed to resend the code. Please try again.");
        }
      });
  }

  return (
    <div style={{ height: "100vh" }}>
      <img className={classes.logo_img} alt="Logo" src={logo}></img>
      <form className={classes.form}>
        <div className={classes.form_Div}>
          <div>
            <h5 id="h5tag">کد مربوطه به صورت پیامک برای شما ارسال گردید </h5>
          </div>

          <input
            type="text"
            placeholder="کد تایید"
            className={classes.input}
            ref={pin}
            required
            id="code"
          />
        </div>
      </form>
      <div className={classes.buttons_Container}>
        <button onClick={resendCode} className={classes.submitButton}>
          ارسال مجدد
        </button>
        <button onClick={enter} className={classes.recieve_SMS}>
          تایید
        </button>
      </div>
      {message && <div className={classes.errorMessage}>{message}</div>}
    </div>
  );
}

export default Register3;
